import { httpGet, httpPost } from "../Web";
import { ApiResponse } from "./ApiResponse";
export enum TestSupportStatus {
    Undecided = 0, Unsupported = 1, Supported = 2, ServerSupported = 3, ClientSupported = 4
};

export const TestSupportStatusStrings = ["Undecided", "Unsupported", "Supported", "ServerSupported", "ClientSupported"];

export type WorkshopTestCaseMap = Map<number /*workshopProductId*/, WorkshopTestCase[]>;

export interface WorkshopTestCase {
    workshopProductId: number,
    testCombinationId: number,
    testCaseId: number,
    supportStatus: TestSupportStatus,
    id?: number
};

export interface WorkshopProductImport {
    workshopProductIdFrom: number,
    workshopProductIdTo: number
};

export const getWSProductTestcases = (workshopProductId: number, abortController: AbortController): Promise<ApiResponse<WorkshopTestCase[]>> =>
    httpGet(`/api/workshopproduct/workshoptestcases/${workshopProductId}`, abortController);

export const importWorkshopProductSettings = (wspi: WorkshopProductImport, abortController: AbortController): Promise<ApiResponse<WorkshopProductImport>> =>
    httpPost(`/api/workshopproduct/settings/import/`, wspi, abortController);

